import React from 'react';

export default class PatientAlerts extends React.Component {
  render() {
    const { alerts } = this.props;

    return (
      <div>
        {alerts && alerts.map((alert, idx) => (
          <span key={idx} className={`label label-${alert.class}`}>
            {' '}
            {alert.name}: {alert.value}
          </span>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/management/components/PatientAlerts.js